import React from 'react';

const PRIMARY = '#6366f1';
const BORDER = '#e5e7eb';
const BG = '#f8fafc';
const TEXT = '#1e293b';
const MUTED = '#64748b';

interface Tenant { id: number; company_name?: string; }

interface Props {
  isSuperAdmin: boolean;
  tenants: Tenant[];
  selectedTenantId: number | null;
  onSelect: (id: number) => void;
  label?: string;
}

export default function CRMTenantBar({ isSuperAdmin, tenants, selectedTenantId, onSelect, label = 'Configuring tenant:' }: Props) {
  if (!isSuperAdmin) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px',
      background: '#eff6ff', border: `1px solid #bfdbfe`, borderRadius: 10,
      marginBottom: 20, flexWrap: 'wrap' as const,
    }}>
      <span style={{ fontSize: 13, color: '#1d4ed8', fontWeight: 600 }}>🏢 {label}</span>
      <select
        value={selectedTenantId ?? ''}
        onChange={e => onSelect(parseInt(e.target.value))}
        style={{ padding: '6px 10px', borderRadius: 7, border: `1px solid ${BORDER}`, fontSize: 13, color: TEXT, background: '#fff', minWidth: 200 }}
      >
        <option value="">— Select a tenant —</option>
        {tenants.map(t => (
          <option key={t.id} value={t.id}>{t.company_name || ''} (ID: {t.id})</option>
        ))}
      </select>
      {selectedTenantId === null && (
        <span style={{ fontSize: 12, color: '#1d4ed8' }}>Select a tenant to manage their CRM settings.</span>
      )}
    </div>
  );
}
